import Swiper from "react-id-swiper";
import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const HeroSlider = ({sliderData}) => {
    const {t} = useTranslation();
    const params = {
        loop: true,
        speed: 1500,
        autoplay: {
            delay: 5000, disableOnInteraction: false,
        },
        effect: "fade",
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
        },
        renderPrevButton: () => (<button className="swiper-button-prev ht-swiper-button-nav"></button>),
        renderNextButton: () => (<button className="swiper-button-next ht-swiper-button-nav"></button>)
    };
    return (<div className="hero-slider-seven">
        <div className="hero-slider-seven__wrapper">
            <Swiper {...params}>
                {sliderData && sliderData.map((single, i) => {
                    const isI18n = Boolean(single.i18nKey);
                    const base = isI18n ? `heroSlider.${single.i18nKey}` : null;
                    const subtitle = isI18n ? t(`${base}.subtitle`) : single.subtitle;
                    const title = isI18n ? t(`${base}.title`) : single.title;
                    const ctaLabel = isI18n ? t(`${base}.cta`) : t("heroSlider.discover");
                    return (<div
                        className="hero-slider-seven__slide bg-img"
                        style={{backgroundImage: `url(${single.bgImage})`}}
                        key={i}
                    >
                        <Container className="h-100">
                            <Row
                                className="content align-items-end flex-column flex-lg-row justify-content-center justify-content-lg-start">
                                <Col lg={7} xl={8} className="mr-auto">
                                    <div className="hero-slider-seven__content">
                                        <h5 className="sub-title">{subtitle}</h5>
                                        <h1
                                            className="title"
                                            dangerouslySetInnerHTML={{__html: title}}
                                        />
                                        {isI18n && (
                                            <p className="availability">{t(`${base}.available`)}</p>
                                        )}
                                        <div className="slider-link">
                                            {single.to ? (
                                                <Link to={single.to}
                                                      className="lezada-button lezada-button--medium"
                                                >
                                                    {ctaLabel}
                                                </Link>
                                            ) : (
                                                <a href={single.url} target="_blank"
                                                   className="lezada-button lezada-button--medium"
                                                   rel="noreferrer"
                                                >
                                                    {ctaLabel}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>);
                })}
            </Swiper>
        </div>
    </div>);
};

export default HeroSlider;